<template>
    <form
        ref="form"
        @submit.prevent="submit"
        :action="formRoute"
        method="POST"
        class="relative h-full"
    >
        <page-header
            :submit-button-text="data ? 'Update' : 'Create'"
            :show-submit-button="true"
            :submit-button-disabled="submitButtonDisabled || !editable"
            submit-button-type="submit"

            :can-delete="canDelete"
            :delete-route="deleteRoute"
            :delete-value="deleteValue"

            :can-create="canCreate"
            :create-route="createRoute"
            :create-value="createValue"

            :index-route="indexRoute"
            :index-value="indexValue"
            :title="title"
            :subtitle="subtitle"

            :show-preview-button="false"

            :errors="errors"
            :is-slide-over="isSlideOver"
        />

        <div
            class="border bg-white rounded-lg w-full p-4 shadow-sm max-w-4xl mt-3"
        >
            <p class="text-gray-700 mb-4">Slot</p>
            <reference
                create-text="Create new slot and link slot to this page"
                link-text="Link an existing slot"
                v-model="form.slot"
                model-data="Slot"
                :query="{
                    'slotReview.status_id': 1
                }"
                :order="{
                    'slots.name': 'asc'
                }"
                :language="form.language"
                :error="errors.slot_id ? errors.slot_id[0] : null"
                :deletable="false"
                :creatable="false"
            />
        </div>

        <div
            class="border bg-white rounded-lg w-full p-4 shadow-sm max-w-4xl mt-3"
            v-show="false"
        >
            <p class="text-gray-700 mb-4">Slot Ranking</p>
            <reference
                create-text="Create new slot ranking and link slot ranking to this page"
                link-text="Link an existing slot ranking"
                v-model="form.slot_ranking"
                model-data="Ranking"
                :error="errors.slot_ranking_id ? errors.slot_ranking_id[0] : null"
                :deletable="false"
                :creatable="false"
            />
        </div>

        <input type="hidden" name="_token" :value="csrf" />
        <input v-if="data" type="hidden" name="_method" value="patch" />
    </form>
</template>

<script>
import crudForm from "../mixins/crudForm";
export default {
    name: "SlotConversionForm",
    mixins: [crudForm],
    data() {
        return {
            form: {
                slot: this.getFormData("slot"),
                slot_id: this.getFormData("slot_id"),
                slot_ranking: this.getFormData("slot_ranking"),
                slot_ranking_id: this.getFormData("slot_ranking_id"),
            },
        };
    },
    watch: {
        "form.slot": function (newValue) {
            this.form.slot_id = newValue ? newValue.id : null;
        },
        "form.slot_ranking": function (newValue) {
            this.form.slot_ranking_id = newValue ? newValue.id : null;
        },
    },
};
</script>
